module.exports = __webpack_public_path__ + "static/book_05-960x550-343d8a4e306f43b054d619f9351a3b3c.jpg";